import iban from 'iban';

export const isIban = (value: string) => {
  return !!iban.isValid(value);
};
